/**
 * @file RnD (Research and Development - Various experiments) route definitions.
 */

import RequireRole from '../components/routing/RequireRole';
import ACCOUNT_ROLES from '../constants/account-roles';
import RndMasterView from '../views/rnd/RndMasterView';
import StyleguideView from '../views/StyleguideView';
import PhotoGridView from '../views/rnd/PhotoGridView';
import SelfieCaptureView from '../views/rnd/SelfieCaptureView';
import MultiSelectView from '../views/rnd/MultiSelectView';
import ErrorTesting from '../views/rnd/ErrorTesting';
import CardsDevView from '../views/rnd/CardsDevView';
import IFrameTesting from '../views/rnd/IFrameTesting';
import VideoRecording from '../views/rnd/VideoRecording';
import CardDesignerView from '../views/rnd/CardDesignerView';
import CollageDesignerView from '../views/rnd/CollageDesignerView';
import DesignerView from '../views/rnd/DesignerView';
import PLICBooksOAuth from '../views/rnd/PLICBooksOAuth';
import AssetImageUpload from '../views/rnd/AssetImageUpload';
import AccountCardPrintProductConfigurationView from '../views/rnd/AccountCardPrintProductConfigurationView';

const RequireAdminRole = RequireRole([ACCOUNT_ROLES.ADMINISTRATOR]);

const routes = [
  {
    path: '/rnd/selfie-capture',
    exact: true,
    component: SelfieCaptureView,
  },
  {
    path: '/open-rnd',
    exact: false,
    component: RndMasterView,
    routes: [
      {
        path: '/open-rnd/video-recording',
        exact: false,
        component: VideoRecording,
      },
    ],
  },
  {
    path: '/rnd',
    exact: false,
    component: RequireAdminRole(RndMasterView),
    routes: [
      {
        path: '/rnd/styleguide',
        exact: true,
        component: StyleguideView,
      },
      {
        path: '/rnd/grid/:albumId',
        exact: true,
        component: PhotoGridView,
      },
      {
        path: '/rnd/multi-select/:albumId',
        exact: true,
        component: MultiSelectView,
      },
      {
        path: '/rnd/iframe',
        exact: true,
        component: IFrameTesting,
      },
      {
        path: '/rnd/error-test',
        exact: true,
        component: ErrorTesting,
      },
      {
        path: '/rnd/cards',
        exact: true,
        component: CardsDevView,
      },
      {
        path: '/rnd/video-recording',
        exact: false,
        component: VideoRecording,
      },
      {
        path: '/rnd/card-designer',
        exact: true,
        component: CardDesignerView,
      },
      {
        path: '/rnd/collage-designer',
        exact: true,
        component: CollageDesignerView,
      },
      {
        path: '/rnd/card-designer/:cardId',
        exact: true,
        component: CardDesignerView,
      },
      {
        path: '/rnd/designer',
        exact: true,
        component: DesignerView,
      },
      {
        path: '/rnd/oauth-plic',
        exact: true,
        component: PLICBooksOAuth,
      },
      {
        path: '/rnd/asset-image-upload',
        exact: true,
        component: AssetImageUpload,
      },
      {
        path: '/rnd/account-card-print-product-configuration/:accountCardId',
        exact: true,
        component: AccountCardPrintProductConfigurationView,
      },
    ],
  },
];

export default routes;
